var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtitles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2839_7716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.666 2.33337H2.33268C1.69102 2.33337 1.16602 2.85837 1.16602 3.50004V10.5C1.16602 11.1417 1.69102 11.6667 2.33268 11.6667H11.666C12.3077 11.6667 12.8327 11.1417 12.8327 10.5V3.50004C12.8327 2.85837 12.3077 2.33337 11.666 2.33337ZM11.666 10.5H2.33268V3.50004H11.666V10.5ZM3.49935 5.83337H4.66602V7.00004H3.49935V5.83337ZM3.49935 8.16671H8.16602V9.33337H3.49935V8.16671ZM9.33268 8.16671H10.4993V9.33337H9.33268V8.16671ZM5.83268 5.83337H10.4993V7.00004H5.83268V5.83337Z",
    fill: "#808190"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2839_7716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitles);
export default __webpack_public_path__ + "static/media/subtitles.8a48d85648da958137436f832c26eed9.svg";
export { ForwardRef as ReactComponent };